<template>
<div class="perusahaan">
               
  <vue-perfect-scrollbar class="chat-history--scrollbar">
    <v-divider></v-divider>
    <v-list two-line class="chat-contact--list">

      <!-- Table Start -->

      <v-flex lg12 md12>
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
          ></v-text-field>

          <v-btn color="primary" @click="gotoTambahkanKontrak"><v-icon>add</v-icon><h5>Tambahkan Kontrak</h5></v-btn>
     
        </v-toolbar>
  
        <v-divider></v-divider>
  
        <v-data-table
          :headers="complex.headers"
          :search="search"
          :items="complex.items"
          :rows-per-page-items="[15,25,50,{text:'All','value':-1}]"
          class="elevation-1 data-fonts"
          item-key="name"
          v-model="complex.selected"
          >
          <template slot="items" slot-scope="props">
            <td class="data-fonts">{{ props.item.kode }}</td>
            <td class="data-fonts">{{ props.item.status }}</td>
            <td class="data-fonts">{{ props.item.penjual }}</td>
            <td class="data-fonts">{{ props.item.pembeli }}</td>
            <td class="data-fonts">{{ props.item.tanggalBerlaku }}</td>
            <td class="data-fonts">{{ props.item.tempatPembayaran.street }}</td>
            <td class="data-fonts">{{ props.item.komoditas }}</td>
            <td class="data-fonts">{{ props.item.musim }}</td>
            <td class="data-fonts">{{ props.item.kuantitas }}</td>
            <td class="data-fonts">{{ props.item.unitKuantitas }}</td>
            <td class="data-fonts">{{ props.item.dibuatPada }}</td>
            <td class="data-fonts">
              <v-btn depressed outline icon fab dark color="primary" small @click="cekDetailKomoditas(props.item.kode)">
                <v-icon>fas fa-file-alt</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>  

      <!-- Table End -->
      
    </v-list>  
  </vue-perfect-scrollbar>  
</div>
</template>

<script>
import { getKontrak } from '@/api/kontrak';
import { Items as Users } from '@/api/kontrak';

import VCircle from '@/components/circle/VCircle';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VWidget from '@/components/VWidget';

export default {
  components: {
    VuePerfectScrollbar,
    VCircle,
    VWidget
  },

  data: () => ({ 
  }),

  data () {
    return {
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'Kode Penjualan',
            value: 'kode'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            text: 'Nama Penjual',
            value: 'penjual'
          },
          {
            text: 'Pembeli',
            value: 'pembeli'
          },
          {
            text: 'Tanggal Berlaku',
            value: 'tanggalBerlaku'
          },
          {
            text: 'Tempat Pembayaran',
            value: 'tempatPembayaran'
          },
          {
            text: 'Komoditas',
            value: 'komoditas'
          },
          {
            text: 'Musim',
            value: 'musim'
          },


          {
            text: 'Kuantitas',
            value: 'kuantitas'
          },
          {
            text: 'Unit Kuantitas',
            value: 'unitKuantitas'
          },
          {
            text: 'Dibuat Pada',
            value: 'dibuat'
          },
          {
            text: 'Tindakan',
            value: ''
          },
        ],
        items: Users
      }
    };
  },

  computed: {
    users () {
      return getUser();
    }
  },

  methods: {

    initialize(){
      this.items = Users;
      console.log("Cek Items : ", this.items);
    },

    deleteItem (item) {
      // const index = this.items.indexOf(item);
      console.log("Item Succesfully Deleted");
    },

    cekDetailKomoditas (id) {
      window.getApp.$emit('APP_KOMODITAS_LOGISTIK');
      // return '/edit-kontrak/' + id;
    },

    gotoTambahkanKontrak(){
      window.getApp.$emit('APP_TAMBAHKAN_KONTRAK');
    },

    firstLetter (name) {
      return name.charAt(0);
    },

    userStatusColor (item) {
      return (item.active) ? 'green' : 'grey';
    }    
  }  
};
</script>

<style scoped>
  .data-fonts{
    font-size: 1em;
  }
</style>
